import * as React from 'react'
import Container from '@/components/Container'
import formatDate from '@/lib/utils/date-format'
import { useRouter } from 'next/router'

import socialLinks from '@/lib/content/social-links'
import ButtonSecondary from '@/components/ButtonSecondary'

import { motion } from 'framer-motion'
import { fadeIn } from '@/lib/utils/framer-motion-config'

import { StandardArticleQuery_entry_articles_article_Entry_articleModules_articleModules_articleTitle_BlockType } from '@/gql/types/StandardArticleQuery'
import { SiteWideQuery_globalSet } from '@/gql/types/SiteWideQuery'

type TitleType = {
    data: StandardArticleQuery_entry_articles_article_Entry_articleModules_articleModules_articleTitle_BlockType
    siteWide: SiteWideQuery_globalSet
    postDate: string
}

const Title: React.FunctionComponent<TitleType> = ({ data, siteWide, postDate }) => {
    const { asPath } = useRouter()

    return (
        <Container maxWidth="sm" paddingYPreset="article">
            <motion.div
                className="flex flex-col items-center justify-center pt-[120px] text-center md:pt-[7.5rem]"
                {...fadeIn}
            >
                {data.heading && (
                    <h1 className="text-xl font-black leading-[28px] md:text-5xl md:leading-[46px]">
                        {data.heading}
                    </h1>
                )}
                <div className="mx-auto mt-6 md:mt-10 md:flex md:space-x-10">
                    <div className="mb-4 text-sm text-[#595959] md:mb-0 md:text-md">
                        {formatDate(postDate)}
                    </div>
                    <div className="flex items-center space-x-4">
                        <div title="Share this article" className="uppercase text-[#595959]">
                            Share this article
                        </div>
                        <div className="flex items-center space-x-5">
                            {socialLinks.map((social, index) => {
                                if (social.shareUrl !== undefined) {
                                    return (
                                        <ButtonSecondary
                                            key={index}
                                            title={`Go to our ${social.name}`}
                                            ariaLabel={`Go to our ${social.name}`}
                                            url={`${social.shareUrl}${process.env.NEXT_PUBLIC_SITE_URL}${asPath}`}
                                            classes="hover:text-opacity-40 text-purple transition duration-300 ease-in-out"
                                            target="_blank"
                                        >
                                            {social.icon}
                                        </ButtonSecondary>
                                    )
                                }
                            })}
                        </div>
                    </div>
                </div>
            </motion.div>
        </Container>
    )
}

export default Title
